import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  colors: {
    primary: '#4a4a4a',
    primaryLight: '#757575',
    primaryDark: '#212121',
    secondary: '#d4af37',
    secondaryLight: '#ffdf6b',
    secondaryDark: '#9e8000',
    background: '#ffffff',
    backgroundAlt: '#f5f5f5',
    text: '#333333',
    textLight: '#757575'
  },
  fonts: {
    body: '"Roboto", "Helvetica", "Arial", sans-serif',
    heading: '"Roboto", "Helvetica", "Arial", sans-serif',
    monospace: 'Menlo, monospace'
  },
  fontSizes: {
    h1: '2.5rem',
    h2: '2rem',
    h3: '1.75rem',
    h4: '1.5rem',
    h5: '1.25rem',
    h6: '1rem',
    body1: '1rem',
    body2: '0.875rem'
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  },
  lineHeights: {
    body: 1.6,
    heading: 1.2
  },
  breakpoints: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
    getMin: (key: string) => {
      const value = theme.breakpoints[key];
      return `@media (min-width: ${typeof value === 'number' ? value : 0}px)`;
    },
    getMax: (key: string) => {
      const value = theme.breakpoints[key];
      return `@media (max-width: ${typeof value === 'number' ? value - 1 : 0}px)`;
    }
  },
  spacing: (multiplier: number) => `${0.25 * multiplier}rem`,
  shadows: {
    sm: '0 1px 3px rgba(0,0,0,0.12)',
    md: '0 4px 6px rgba(0,0,0,0.1)',
    lg: '0 10px 15px rgba(0,0,0,0.1)',
    xl: '0 20px 25px rgba(0,0,0,0.1)'
  },
  transitions: {
    default: '0.3s ease',
    fast: '0.15s ease',
    slow: '0.45s ease'
  },
  borderRadius: {
    sm: '0.125rem',
    md: '0.25rem',
    lg: '0.5rem',
    xl: '1rem'
  }
};

// Apply responsive font sizes and export
export default theme;
